function Backdrop() {
  return <div className='z-top-of-chatbot-plus2 fixed inset-0 hidden bg-gray-900 opacity-40 lg:block' data-sentry-component="Backdrop" data-sentry-source-file="backdrop.tsx"></div>;
}
export default Backdrop;